import { Box } from "@mui/system";
import "assets/css/styles.css";
import arrowHopelapp from "assets/images/arrow-hopelapp.png";
import brandIconWhite from "assets/images/brands/icon-white.png";
import { useEffect, useState } from "react";

interface LoadingPageProps {
  message?: string;
}

const LoadingPage: React.FC<LoadingPageProps> = ({ message }) => {
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  let fontSize = 100;

  if (screenWidth < 450) {
    fontSize = 50;
  } else if (screenWidth < 550) {
    fontSize = 90;
  } else fontSize = 100;

  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "#357f84",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999,
        overflow: "hidden",
      }}
    >
      <div className="container">
        <div className="row">
          <Box>
            <div
              className="title bounced avenir"
              style={{ fontSize: `${fontSize}px`, color: "#FFFFFF" }}
            >
              H<div className="letter">o</div>pelapp
            </div>
          </Box>
          {message && (
            <Box sx={{ mt: 3 }}>
              <div
                style={{
                  color: "rgba(255, 255, 255, 0.9)",
                  fontSize: window.innerWidth < 600 ? "0.9rem" : "1rem",
                  textAlign: "center",
                }}
              >
                {message}
              </div>
            </Box>
          )}
        </div>
      </div>
    </Box>
  );
};

export default LoadingPage;

